import * as Stitches from '@stitches/react';
import { keyframes, styled } from '@gbm-tech/styles';

export const SubItemMenuContainer = styled('nav', {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

const SubItemContainerLG: Stitches.CSS = {
  gap: '1.2rem',

  '.arrow': {
    padding: '0.32rem',
  },
};

const SubItemContainerXL: Stitches.CSS = {
  gap: '1.4rem',

  span: {
    fontSize: '1.8rem',
    lineHeight: '3.2rem',
  },
};

const SubItemContainerXXL: Stitches.CSS = {
  gap: '1.6rem',
};

const SubItemContainerHover: Stitches.CSS = {
  backgroundColor: '#eceef2',
};

export const SubItemContainer = styled('button', {
  padding: '1.2rem 1.6rem 1.2rem 2.2rem',

  display: 'flex',
  alignItems: 'center',
  gap: '1rem',

  border: 'none',
  outline: 'none',
  borderBottom: '1.5px solid $blue50',
  backgroundColor: 'white',

  textDecoration: 'none',

  cursor: 'pointer',
  transition: 'all ease-in-out 0.4s',

  '> span': {
    flex: 1,

    textAlign: 'left',
    fontSize: '1.6rem',
    lineHeight: '2.8rem',
    fontWeight: 400,

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    color: '#404a59',
  },

  '.arrow': {
    size: '2.4rem',
    padding: '0.4rem',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '$gray500',

    backgroundColor: 'transparent',
    border: '1px solid #dae0e7',
    borderRadius: '4px',

    svg: {
      size: '100%',
      color: '#404a59',
      transition: 'transform 0.2s',
    },

    '&.is-open': {
      svg: {
        transform: 'rotate(90deg)',
      },
    },
  },

  '&:hover': { ...SubItemContainerHover },

  '@lg': { ...SubItemContainerLG },

  '@xl': { ...SubItemContainerXL },

  '@xxl': { ...SubItemContainerXXL },
});

const dropdownH = keyframes({
  '0%': { opacity: 0, maxHeight: 0 },
  '100%': { opacity: 1, maxHeight: '20rem' },
});

export const SubPagesContainer = styled('div', {
  flexDirection: 'column',

  overflow: 'hidden',

  animationDuration: '300ms',
  animationTimingFunction: 'linear',
  animationName: dropdownH.toString(),

  variants: {
    visible: {
      true: {
        display: 'flex',
      },

      false: {
        display: 'none',
      },
    },
  },
});
